// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.AuthenApi.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import AppGlobal from 'Izenda.AppGlobal';
import SecurityManager from 'share/authorization/Izenda.SecurityManager';

const securityManager = new SecurityManager();
const AuthenApi = {

  /**
   * This function is intended to pass the user context info.
   * @param {Object} currentUserContext context object e.g. {token: 'CUSTOM_TOKEN'}
   * @param {boolean} keepPermissionSettings whether we need to keep current user setting or need to reset it.
   */
  setCurrentUserContext(currentUserContext: any, keepPermissionSettings) {
    ensure(currentUserContext , 'Must be set current user context');
    if (currentUserContext.token !== AppGlobal.currentUserContext.token) {
      AppGlobal.currentUserContext.token = currentUserContext.token;
      if (!keepPermissionSettings)
        securityManager.clearPermission();
    }
  }
};

export default AuthenApi;



// WEBPACK FOOTER //
// ./ui/api/Izenda.AuthenApi.js